export default __webpack_public_path__ + "static/media/thumb_up.791b0b98.svg";